module.exports = __webpack_public_path__ + "static/media/gasStation.49accdbf.svg";